"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaIcon = function MediaIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "22px", height: "16px", viewBox: "0 0 22 16", version: "1.1" },
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", {
        d: "M21.6666667,2.20833333 L21.6666667,13.4583333 L16.25,9.87878788 L16.25,\n        5.78787879 L21.6666667,2.20833333 Z M16.25,13.3333333 C16.25,14.4378333 15.4184643,\n        15.3333333 14.3928571,15.3333333 L1.85714286,15.3333333 C0.831535714,\n        15.3333333 0,14.4378333 0,13.3333333 L0,2.33333333 C0,1.22883333 0.831535714,\n        0.333333333 1.85714286,0.333333333 L14.3928571,0.333333333 C15.4184643,0.333333333 16.25,\n        1.22883333 16.25,2.33333333 L16.25,13.3333333 Z",
        fill: "#FFFFFF"
      })
    )
  );
};

exports.default = MediaIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/MediaIcon/MediaIcon.js
// module id = 604
// module chunks = 11